export const saveRecordMsg = "Record Saved Successfully.";

export const updateRecordMsg = "Record Updated Successfully.";

export const failedToUpdateRecordMsg = "Record Updation failed. Please try again later.";

export const fileDeletionMsg = "File deleted Successfully.";

export const DATE_TIME_DISPLAY_FORMAT = "DD MMM YYYY hh:mm:ss a";
export const EXCEL_DATE_TIME_FILENAME_FORMAT = "_YYYYMMDD_HHmmss";

export const StatusMaster = {
  Knowledge: {
    Draft: 1,
    Pending: 2,
    Sentback: 3,
    Rejected: 4,
    Approved: 5,
  },
  KnowledgeBulkUpload: {
    Pending: 11,
    Success: 15,
    Error: 16,
  },
  KnowledgeVerification: {
    Verified: 26,
    Unverified: 27,
  }
}
